export default {
  image: {
    position: 'relative',
    objectFit: 'cover'
  }
};